<template>
    <survey-badge :variant="color" hover>
        {{ score }}
    </survey-badge>
</template>
<script src="./ScoreBadge.ts"></script>
